/**
 * @generated SignedSource<<4a6204e5c191d76076e36d59d2f6379b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PinnedCommentDisplay$data = {
  readonly id: string;
  readonly pinnedIssueComment: {
    readonly issueComment: {
      readonly author: {
        readonly avatarUrl: string;
        readonly login: string;
        readonly profileUrl: string | null | undefined;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly shortBodyHTML: string;
      readonly url: string;
      readonly viewerCanUnpin: boolean;
    };
    readonly pinnedBy: {
      readonly login: string;
    };
  } | null | undefined;
  readonly " $fragmentType": "PinnedCommentDisplay";
};
export type PinnedCommentDisplay$key = {
  readonly " $data"?: PinnedCommentDisplay$data;
  readonly " $fragmentSpreads": FragmentRefs<"PinnedCommentDisplay">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PinnedCommentDisplay",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PinnedIssueComment",
      "kind": "LinkedField",
      "name": "pinnedIssueComment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "pinnedBy",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueComment",
          "kind": "LinkedField",
          "name": "issueComment",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "limit",
                  "value": 700
                },
                {
                  "kind": "Literal",
                  "name": "stripBlockElements",
                  "value": false
                }
              ],
              "kind": "ScalarField",
              "name": "shortBodyHTML",
              "storageKey": "shortBodyHTML(limit:700,stripBlockElements:false)"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanUnpin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "avatarUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "0947ca400a9901304a0d2d26131347b5";

export default node;
